module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "TOC_Chapter-Title",
    attrs: {
      "id": "uiahBLVgFyO3U33OGZhW5LA"
    }
  }, [_c('a', {
    attrs: {
      "id": "uvNpkIO9xu4Pm5KQ9FSn6jG"
    }
  }), _vm._v("Don’t Be A Dick")]), _vm._v(" "), _c('p', {
    staticClass: "Style-Group-1_Normal"
  }, [_vm._v("Growing up, my kids had two household rules: “Don’t be a dick” and “If it’s not yours, don’t touch it.”")]), _vm._v(" "), _c('br'), _c('p', {
    staticClass: "Style-Group-1_Normal"
  }, [_vm._v("(And honestly the second rule is really covered by the first, but a couple people I gave birth to had some struggles with the “stop fucking with other people’s stuff” portion of the program, so we had Rule Two. But I digress.)")]), _vm._v(" "), _c('br'), _c('p', {
    staticClass: "Style-Group-1_Normal"
  }, [_vm._v("This rule was so well known that everyone who was invested in the welfare of my kids (teachers, counselors, etc.) would invoke it: “Well, are you being a dick right now?”")]), _vm._v(" "), _c('br'), _c('p', {
    staticClass: "Style-Group-1_Normal"
  }, [_vm._v("Thank you, Wil Wheaton, for adding “Don’t be a dick” to our common vernacular. Because, seriously, if you are only going to have one life rule, have it be this one. You don’t need an explanation on this one. You know when you are being a dick. Don’t.")]), _vm._v(" "), _c('br'), _c('p', {
    staticClass: "Style-Group-1_Normal"
  }, [_vm._v("When this now-book was first released as a zine, I wondered if “Don’t be a dick” would resonate and make sense with the people who read it. Or would there be a bunch of “Dude, what the fuck do you mean by that?” going on. Not once has that happened. This is a rule that everyone totally intuits immediately. We know what dickitude looks like in all its shapes and forms. If we call it out in ourselves and refuse to tolerate it in others, we are already acting way more grown than most motherfuckers out there.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0ed6a84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/adulting2.vue
// module id = 63
// module chunks = 0